// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"12c282b0","238":"2dafb46a","241":"5ac58999","373":"2bd7e96d","724":"00dfa59a"}[chunkId] + ".chunk.css";
};